<template>
  <div :class="$route.params.pointId ? 'container-fluid' : 'container'" class="pb-5">
    <debt-by-point-id :allow-printing="true" v-if="$route.params.pointId"></debt-by-point-id>
    <div v-else>
      <div class="pb-3">
        <div class="row">
          <div class="col"></div>
          <div class="col col-auto">
            <select class="form-control" v-model="selectedTour">
              <option value="">Все объезды</option>
              <option :value="tour.Id" v-for="tour in tours">{{tour.Name}}</option>
            </select>
          </div>
          <div class="col col-auto">
            <select class="form-control" v-model="selectedPType">
              <option value="">Все типы оплаты</option>
              <option :value="pt.Id" v-for="pt in $root.paymentTypes">{{pt.Name}}</option>
            </select>
          </div>
          <div class="col col-auto">
            <button @click.prevent="print" class="btn btn-warning ml-2">Печать
            </button>
          </div>
        </div>
      </div>
      <div id="printMe">
      <legend>Долги по клиентам на {{currentDate}}</legend>
      <table class="table table-bordered table-hover table-sm">
        <thead>
        <tr>
          <th>Объезд</th>
          <th>Приемный пункт</th>
          <th v-for="paymentType in $root.paymentTypes">
            {{paymentType.Name}}
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(pTour, index) in pointByTour">
          <tr v-for="(pointStat, index) in pTour">
            <td class="font-weight-bold">{{index === 0 ? pointStat.TourName : ''}}</td>
            <td>
              <router-link
                :to="{ name: 'debt-point-stats', params:{pointId:pointStat.PointId}}">
                {{pointStat.Reception}}
              </router-link>
            </td>
            <th v-for="paymentType in $root.paymentTypes">
              {{pointStat.Stats[paymentType.Id] ? pointStat.Stats[paymentType.Id].PaymentTypeSummary
              :
              ''}}
            </th>
          </tr>
        </template>
        </tbody>
      </table>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from '@/admin/services/api/http-utils';
import PointDebt from '@/admin/modules/Debt/_components/PointDebt.vue';
import DebtByPointId from '@/admin/modules/Debt/_components/DebtByPointId.vue';
import _ from 'lodash';
import moment from 'moment';

const queryString = require('query-string');

const url = `${process.env.VUE_APP_API_HOST}admin/debt`;

const now = moment().format('L');
export default {
  components: {
    PointDebt,
    DebtByPointId,
  },
  data() {
    return {
      pointStats: [],
      selectedPType: '',
      selectedTour: '',
      currentDate: now,
      tours:[],
    };
  },
  computed: {
    pointByTour() {
      if (!this.pointStats) {
        return [];
      }
      let res = _.groupBy(this.pointStats, 'TourName');
      res = _.map(res, g => _.orderBy(g, 'Total', 'desc'));
      return res;
    },
    // totalOrderCount() {
    //   if (this.tourStats) {
    //     return _.sumBy(this.tourStats, o => +o.Count);
    //   }
    //   return 0;
    // },
    // formattedPointStats() {
    //   if (this.pointStats) {
    //     let formattedPointStats = _.groupBy(this.pointStats, ps => ps.PaymentTypeId);
    //      formattedPointStats = _.map(formattedPointStats, psg => {
    //        return _.groupBy(psg, (ps) => ps.PointId);
    //      });
    //     // formattedPointStats = _.groupBy(formattedPointStats, pstat => pstat.PointId);
    //     return formattedPointStats;
    //   }
    //   return [];
    // },
  },
  async mounted() {
    await this.fetchPointStats();
    await this.fetchTours();
  },
  watch: {
    async selectedPType() {
      await this.fetchPointStats();
    },
    async selectedTour() {
      await this.fetchPointStats();
    },
  },
  methods: {
    async fetchPointStats() {
      const query = queryString.stringify({ pType: this.selectedPType, tourId: this.selectedTour });
      const { data } = await get(`${url}/point-stat-table?${query}`);
      this.pointStats = data;
    },
    async fetchTours() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/tour`);
      this.tours = data;
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    // totalSummaryByPtId(ptId) {
    //   return _.sumBy(this.tourStats, o => +o.PTypes[ptId].Summary || 0);
    // },
  },
};
</script>
